export interface IOrganization {
  id?: number;
  name?: string;
  description?: string | null;
}

export const defaultValue: Readonly<IOrganization> = {};
